import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as AlertWarningIcon } from "../../../common/icons/alertWarning.svg";
import { ReactComponent as SuccessIcon } from "../../../common/icons/checkGreen.svg";

type Props = {
  talentCount: number;
  orderedAmount: number;
};

export const PoolTalentsInfo = ({ talentCount, orderedAmount }: Props) => {
  const { t } = useTranslation("order");

  return (
    <Box display="flex" alignContent="center">
      {talentCount >= orderedAmount ? (
        <SuccessIcon
          style={{ marginRight: "10px", height: "20px", width: "20px" }}
        />
      ) : (
        <AlertWarningIcon
          style={{
            marginRight: "10px",
            marginTop: "2px",
            height: "20px",
            width: "20px",
          }}
        />
      )}
      <Typography fontWeight={600}>
        {t("poolAvailableTalents", { count: talentCount })}
      </Typography>
    </Box>
  );
};
